import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    '&, *': {
      boxSizing: 'border-box',
    },
    listStyle: 'none',
    padding: '0.5rem 0.625rem',
    fontFamily: theme.value.typography.fontFamily,
    fontSize: '0.875rem',
    fontWeight: '400',
    lineHeight: '1.25rem',
    color: theme.value.colors.gray.main,
    cursor: 'pointer',
    transition: 'background-color 120ms ease, color 120ms ease',
    '&--with-separator': {
      borderBottom: `1px solid ${theme.value.colors.gray.light3}`,
    },
    '&--highlighted': {
      backgroundColor: theme.value.colors.gray.light3,
      borderRadius: '4px',
      boxShadow: 'inset 0 3px #fff, inset 0 -3px #fff',
    },
    '&--selected': {
      backgroundColor: theme.value.colors.primary.light5,
      borderRadius: '4px',
      boxShadow: 'inset 0 3px #fff, inset 0 -3px #fff',
      color: theme.value.colors.primary.main,
      fontWeight: theme.value.typography.fontWeight.semibold,
    },
    '&--disabled': {
      color: theme.value.colors.gray.medium2,
      cursor: 'not-allowed',
      pointerEvents: 'none',
    },
  }));

  return baseClass;
};
